import { styled } from 'shared/Houston';

export const Container = styled.div`
  justify-self: center;
  text-align: center;
`;
